import { painting } from "../art/paintings";
import Reveal from "../Reveal";

/**
 * The painted couple on the swing, shown right after the bride & groom.
 * Uses src/images/royal-mahal/couple.(webp|png|jpg); renders nothing until it exists.
 */
const CouplePortrait = () => {
  const src = painting("couple");
  if (!src) return null;
  return (
    <section className="rm-couple-portrait" aria-label="The couple">
      <Reveal effect="fade" className="rm-couple-portrait__inner">
        <img className="rm-couple-portrait__img" src={src} alt="The bride and groom on a flower-decked swing" loading="lazy" decoding="async" />
      </Reveal>
    </section>
  );
};

export default CouplePortrait;
